module.exports = __webpack_public_path__ + "static/media/loc3_img13.4648dc77.jpg";